import { useState } from 'react'
import {
  AI_PROVIDER_OPTIONS,
  TEXT_MODEL_OPTIONS,
  type AIProviderId,
  type TextModelSelectionId,
} from '@creanizer/types'
import { useSettingsStore } from '../../stores/settingsStore'

export function AIProviderSettings() {
  const [error, setError] = useState<string | null>(null)
  const {
    selectedProvider,
    selectedModelId,
    setSelectedProvider,
    setSelectedModel,
  } = useSettingsStore()
  const models = TEXT_MODEL_OPTIONS.filter(
    model => model.provider === selectedProvider
  )
  const changeProvider = async (provider: AIProviderId) => {
    try {
      setError(null)
      await setSelectedProvider(provider)
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : '設定の保存に失敗しました')
    }
  }
  const changeModel = async (modelId: TextModelSelectionId) => {
    try {
      setError(null)
      await setSelectedModel(modelId)
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : '設定の保存に失敗しました')
    }
  }

  return (
    <div className="grid gap-4 rounded border border-gray-200 p-4">
      <div>
        <label className="mb-2 block text-sm font-medium" htmlFor="ai-provider">
          APIプロバイダー
        </label>
        <select
          id="ai-provider"
          className="input"
          value={selectedProvider}
          onChange={event => {
            void changeProvider(event.target.value as AIProviderId)
          }}
        >
          {AI_PROVIDER_OPTIONS.map(provider => (
            <option key={provider.id} value={provider.id}>
              {provider.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="mb-2 block text-sm font-medium" htmlFor="ai-model">
          使用モデル
        </label>
        <select
          id="ai-model"
          className="input"
          value={selectedModelId}
          onChange={event => {
            void changeModel(event.target.value as TextModelSelectionId)
          }}
        >
          {models.map(model => (
            <option key={model.id} value={model.id}>
              {model.label}
            </option>
          ))}
        </select>
      </div>
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  )
}
